// Polite, calming reminder phrases for cheques (Arabic + English).
// Rotates messages so users don't see the same wording twice in a row.

export const REMINDER_AR = [
  "تذكير لطيف: لديك شيك بمبلغ {amount} {ccy} يستحق خلال {days} أيام. لا داعي للقلق، خذ راحتك.",
  "☕ صباح الخير! باقي {days} أيام على شيك {payee} ({amount} {ccy}). فقط تذكير ودّي.",
  "🌿 هدوء وسكينة — شيك {payee} يستحق خلال {days} أيام. الوقت لا يزال أمامك.",
  "بلطف: شيك بقيمة {amount} {ccy} قريب من الاستحقاق (خلال {days} أيام). كل شيء تحت السيطرة.",
  "🌸 لا تنسَ فقط: شيك {payee} خلال {days} أيام. لا حاجة للتوتر.",
];

export const REMINDER_EN = [
  "Gentle nudge: a {amount} {ccy} cheque is due in {days} days. Take it easy.",
  "☕ Good morning! {days} days left on your {payee} cheque ({amount} {ccy}). Friendly reminder.",
  "🌿 Just so you know — {payee} cheque due in {days} days. Plenty of time.",
  "Kindly: {amount} {ccy} cheque coming up in {days} days. All under control.",
  "🌸 Soft reminder: {payee} cheque in {days} days. No stress.",
];

const OVERDUE_AR = "تذكير هادئ: شيك {payee} ({amount} {ccy}) تجاوز موعده. لا مشكلة، فقط راجعه عند اقتنائك للوقت.";
const OVERDUE_EN = "Calm reminder: {payee} cheque ({amount} {ccy}) has passed its date. No stress — review when you can.";

const TODAY_AR = "🕊️ اليوم موعد شيك {payee} ({amount} {ccy}). خذ نفساً عميقاً — كل شيء بخير.";
const TODAY_EN = "🕊️ Today is the day for {payee} cheque ({amount} {ccy}). Deep breath — you've got this.";

export function pickReminder({ lang, days, amount, ccy, payee }) {
  const fmt = (s) => s.replace(/\{amount\}/g, Number(amount).toFixed(0))
    .replace(/\{ccy\}/g, ccy || "").replace(/\{payee\}/g, payee || "").replace(/\{days\}/g, String(days));
  if (days < 0) return fmt(lang === "ar" ? OVERDUE_AR : OVERDUE_EN);
  if (days === 0) return fmt(lang === "ar" ? TODAY_AR : TODAY_EN);
  const pool = lang === "ar" ? REMINDER_AR : REMINDER_EN;
  const idx = Math.abs((Math.floor(new Date().getTime() / 86400000) + days) % pool.length);
  return fmt(pool[idx]);
}
